module.exports = __webpack_public_path__ + "img/logo_onebox-vertical-png.643be0b2.png";